// @ts-nocheck
import {useCallback, useEffect, useState} from "react";
import {staticData} from "../../pages/private/Games/components/CasinoList/staticData";

export const useWebSocket = displayedGames => {
  const [tableData, setTableData] = useState([]);

  const findMatchingKeys = useCallback(() => {
    const liveGameIds = displayedGames.map(game => parseInt(game.id, 10));
    const allStaticKeys = Object.values(staticData).flat(2);
    return liveGameIds.filter(id => allStaticKeys.includes(id));
  }, [displayedGames]);

  useEffect(() => {
    const ws = new WebSocket("wss://dga.pragmaticplaylive.net/ws");

    ws.onopen = () => {
      const message = {
        type: "available",
        casinoId: "ppcnt00000006020",
      };
      ws.send(JSON.stringify(message));
    };

    ws.onmessage = event => {
      const response = JSON.parse(event.data);
      if (response.tableId) {
        setTableData(prevData => {
          const existingTableIndex = prevData.findIndex(table => table.tableId === response.tableId);

          // Create a copy of the previous data
          const updatedData = [...prevData];

          if (existingTableIndex !== -1) {
            // If table exists, update it
            const existingTable = updatedData[existingTableIndex];
            const updatedTable = {
              ...existingTable,
              ...response,
              tableLimits: response.tableLimits
                ? {
                    ...existingTable.tableLimits,
                    ...response.tableLimits,
                    ranges: response.tableLimits.ranges || existingTable.tableLimits.ranges,
                    minBet:
                      response.tableLimits.minBet !== undefined
                        ? response.tableLimits.minBet
                        : existingTable.tableLimits.minBet,
                    maxBet:
                      response.tableLimits.maxBet !== undefined
                        ? response.tableLimits.maxBet
                        : existingTable.tableLimits.maxBet,
                  }
                : existingTable.tableLimits,
            };

            updatedData[existingTableIndex] = updatedTable;
          } else {
            updatedData.push(response);
          }

          return updatedData;
        });
      }

      if (response.tableKey) {
        const matchingKeys = findMatchingKeys();
        const subscribeMessage = {
          type: "subscribe",
          casinoId: "ppcnt00000006020",
          key: matchingKeys,
          isDeltaEnabled: true,
        };

        ws.send(JSON.stringify(subscribeMessage));
      }
    };

    ws.onerror = _error => {};

    ws.onclose = () => {};

    return () => {
      if (ws) {
        ws.close();
      }
    };
  }, [displayedGames, findMatchingKeys]);

  return {tableData};
};
